import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router';
import CoolBackground from '@/components/CoolBackground.vue';
import { useAuth } from '@/store/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'landing',
  setup(__props, { expose: __expose }) {
  __expose();

const auth = useAuth();
const router = useRouter();

const goToLogin = () => {
	if(!auth.user){
        router.push({ name: 'Auth', params: { pageState: `signup` } });
	}else{
		router.push('/upload');
	}
};

const __returned__ = { auth, router, goToLogin, get useRouter() { return useRouter }, CoolBackground, get useAuth() { return useAuth } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})